// extracted by mini-css-extract-plugin
module.exports = {"Container":"CardListStatsCards_Container__3dMmM","card-list-item-slide":"CardListStatsCards_card-list-item-slide__yXyQj"};